import { calculateBalancedCenter } from "./calculate-balanced-center";
import { calculatePoleOfInaccessibility } from "./calculate-pole-of-inaccessibility";
import { difference } from "./difference";
import { union } from "./union";

export const SpatialUtils = {
    union,
    difference,
    calculateBalancedCenter,
    calculatePoleOfInaccessibility,
};

export { WGS84_POLE_OF_INACCESSIBILITY_PRECISION } from "./calculate-pole-of-inaccessibility";
